import type { TextareaProps } from '@mantine/core';
import { Textarea } from '@mantine/core';
import React from 'react';

import styles from './TextArea.module.css';

export const LBTextArea = React.forwardRef<
  React.ElementRef<typeof Textarea>,
  TextareaProps
>((props, ref) => <Textarea {...props} ref={ref} classNames={styles} />);
